/**
 * activity GET /tags — the tags a vessel can put on its events: the default
 * (system) ones every vessel shares, plus the vessel's own. A default tag has
 * no `vessel_id`.
 */
export interface TagDto {
  id: string;
  vessel_id: string | null;
  name: string;
  color: string | null;
  is_default: boolean;
}

/**
 * The chef's tag. activity derives `has_menu` from it, and the calendar's
 * "With meals" filter already covers it, so it is not offered as a tag filter.
 */
export const MENU_TAG_NAME = 'Menu';
